// extracted by mini-css-extract-plugin
export var centerText = "_f7-8";
export var container = "_f7-0";
export var doughnutContainer = "_f7-7";
export var legend = "_f7-a";
export var legendItemColorDisplay = "_f7-b";
export var legendItemLabel = "_f7-d";
export var legendItemValue = "_f7-c";
export var lg = "_f7-5";
export var maxWidth = "_f7-9";
export var md = "_f7-4";
export var responsive = "_f7-6";
export var sm = "_f7-3";
export var xs = "_f7-2";
export var xxs = "_f7-1";